module.exports = __webpack_public_path__ + "img/substance-ddmg-logo.843e7071.png";